import { type HTMLAttributes, type ReactElement, type ReactNode } from "react";

import * as S from "./styled";

export type BannerKind = "info" | "warning" | "danger";

type BannerProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  actions?: ReactNode;
  kind?: BannerKind;
  title?: ReactNode;
};

export const Banner = ({
  children,
  actions,
  kind = "info",
  title,
  ...props
}: BannerProps): ReactElement => {
  return (
    <S.Wrapper $kind={kind} {...props}>
      <S.Content>
        {title && <S.Title>{title}</S.Title>}
        {children}
      </S.Content>
      {actions && <S.Actions>{actions}</S.Actions>}
    </S.Wrapper>
  );
};
